import { ChakraText, EquipUITheme } from '@equip.health/ui';

import { MaudPermissions } from '~/lib/constants/permissions.constants';
import { useGlobalContext } from '~/lib/contexts/GlobalContext';

import AvailabilityRules from '../availability';

const { paragraph } = EquipUITheme.typography;

const Availability = () => {
  const { calendarAccount, permissions } = useGlobalContext();
  const isSchedulingAdmin = permissions[MaudPermissions.MAUD_SCHEDULE_PROXY];

  if (!isSchedulingAdmin && !calendarAccount?.profileConnected) {
    return (
      <ChakraText
        {...paragraph}
        id="availability__not-authorized-helper"
        padding="8px"
      >
        Link your calendar from the &quot;Integration&quot; tab before managing
        your availability
      </ChakraText>
    );
  }

  return <AvailabilityRules />;
};

export default Availability;
